/** @jsx jsx */
import { jsx } from '@emotion/react';

import Button from '@atlaskit/button';
import Modal, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';
import CloseIcon from '@atlaskit/icon/glyph/editor/close';
import { hideOnMobileNavigationStyles } from '@af/design-system-docs-ui';

import SearchClient from './client';

interface SearchProps {
  isOpen: boolean;
  onClose(): void;
  testId?: string;
}

const Search = ({ isOpen, onClose, testId }: SearchProps) => {
  return (
    <ModalTransition>
      {isOpen && (
        <Modal
          onClose={onClose}
          shouldScrollInViewport
          testId={testId ? `${testId}-modal` : undefined}
        >
          <SearchClient
            onResultClick={onClose}
            testId={testId}
            closeButton={
              <Button
                appearance="subtle"
                onClick={onClose}
                iconBefore={<CloseIcon label="Close navigation" />}
              />
            }
          />
          <div css={hideOnMobileNavigationStyles}>
            <ModalFooter>
              <Button appearance="subtle" onClick={onClose}>
                Close
              </Button>
            </ModalFooter>
          </div>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default Search;
